<template>
  <div class="text-center">
    <v-dialog
        v-model="dialog"
        width="500"
        persistent
    >
      <v-card class="tw-px-2">
        <card-title>Session Expiring Soon</card-title>

        <v-card-text class="tw-text-xl tw-mt-4 tw-text-center">
          <p>You have left this browser idle for some time.</p>
          <p class="tw-font-bold tw-text-red-500 tw-mt-4">
            Your session will expire in {{ formattedTime }}.
          </p>
          <p class="tw-text-base tw-mt-4 tw-text-gray-600">
            Do you want to stay logged in?
          </p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="tw-justify-center tw-py-4">
          <v-btn
              color="error"
              text
              @click="performLogout"
          >
            Logout Now
          </v-btn>
          <v-btn
              color="primary"
              elevation="0"
              @click="stayLoggedIn"
              class="tw-ml-4"
          >
            Stay Logged In
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { NOTIFICATIONS } from '@/utils/const';
import CardTitle from '@/components/shared/CardTitle';

export default {
  name: 'ScreenIdle',
  components: { CardTitle },
  props: ['dialog'],
  data() {
    return {
      countdown: 300, // 5 minutes in seconds
      timer: null,
    };
  },
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.countdown / 60);
      const seconds = this.countdown % 60;
      return `${minutes}m ${seconds.toString().padStart(2, '0')}s`;
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.startCountdown();
      } else {
        this.stopCountdown();
      }
    },
  },
  methods: {
    startCountdown() {
      this.countdown = 300;
      this.stopCountdown();
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown -= 1;
        } else {
          this.performLogout();
        }
      }, 1000);
    },
    stopCountdown() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    stayLoggedIn() {
      // By trying to "close" the dialog, we actually need to reset IdleVue state.
      // Easiest is to force a reload or emit an event to simulate activity,
      // but reloading the window slightly is cleanest for Vue-Idle resetting without user mouse movement.
      // However, we can also dispatch an event to the document.
      document.dispatchEvent(new Event('mousemove'));
      this.stopCountdown();
      // The parent components control `dialog` via `isAppIdle` which clears when activity occurs
    },
    performLogout() {
      this.stopCountdown();
      this.$store.dispatch('auth/signOut').then(() => {
        localStorage.removeItem(NOTIFICATIONS);
        if (caches) {
          caches.keys().then((arr) => {
            arr.forEach((key) => {
              caches.delete(key);
            });
          });
        }
        this.$store.commit('setClient', []);
        window.location.href = '/signin';
      });
    },
  },
  beforeDestroy() {
    this.stopCountdown();
  },
};
</script>
